/* tslint:disable */
/* eslint-disable */
/**
 * DIV.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CompanyOverviewDtoSortingRequestDto } from './CompanyOverviewDtoSortingRequestDto';
import {
    CompanyOverviewDtoSortingRequestDtoFromJSON,
    CompanyOverviewDtoSortingRequestDtoFromJSONTyped,
    CompanyOverviewDtoSortingRequestDtoToJSON,
    CompanyOverviewDtoSortingRequestDtoToJSONTyped,
} from './CompanyOverviewDtoSortingRequestDto';
import type { SearchRequestDto } from './SearchRequestDto';
import {
    SearchRequestDtoFromJSON,
    SearchRequestDtoFromJSONTyped,
    SearchRequestDtoToJSON,
    SearchRequestDtoToJSONTyped,
} from './SearchRequestDto';
import type { FilterRequestDto } from './FilterRequestDto';
import {
    FilterRequestDtoFromJSON,
    FilterRequestDtoFromJSONTyped,
    FilterRequestDtoToJSON,
    FilterRequestDtoToJSONTyped,
} from './FilterRequestDto';
import type { PagingRequestDto } from './PagingRequestDto';
import {
    PagingRequestDtoFromJSON,
    PagingRequestDtoFromJSONTyped,
    PagingRequestDtoToJSON,
    PagingRequestDtoToJSONTyped,
} from './PagingRequestDto';

/**
 * 
 * @export
 * @interface CompanyOverviewDtoFilterSortSearchPagedRequestDto
 */
export interface CompanyOverviewDtoFilterSortSearchPagedRequestDto {
    /**
     * 
     * @type {FilterRequestDto}
     * @memberof CompanyOverviewDtoFilterSortSearchPagedRequestDto
     */
    filters?: FilterRequestDto;
    /**
     * 
     * @type {SearchRequestDto}
     * @memberof CompanyOverviewDtoFilterSortSearchPagedRequestDto
     */
    search?: SearchRequestDto;
    /**
     * 
     * @type {PagingRequestDto}
     * @memberof CompanyOverviewDtoFilterSortSearchPagedRequestDto
     */
    paging?: PagingRequestDto;
    /**
     * 
     * @type {CompanyOverviewDtoSortingRequestDto}
     * @memberof CompanyOverviewDtoFilterSortSearchPagedRequestDto
     */
    sorting?: CompanyOverviewDtoSortingRequestDto;
}

/**
 * Check if a given object implements the CompanyOverviewDtoFilterSortSearchPagedRequestDto interface.
 */
export function instanceOfCompanyOverviewDtoFilterSortSearchPagedRequestDto(value: object): value is CompanyOverviewDtoFilterSortSearchPagedRequestDto {
    return true;
}

export function CompanyOverviewDtoFilterSortSearchPagedRequestDtoFromJSON(json: any): CompanyOverviewDtoFilterSortSearchPagedRequestDto {
    return CompanyOverviewDtoFilterSortSearchPagedRequestDtoFromJSONTyped(json, false);
}

export function CompanyOverviewDtoFilterSortSearchPagedRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CompanyOverviewDtoFilterSortSearchPagedRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'filters': json['filters'] == null ? undefined : FilterRequestDtoFromJSON(json['filters']),
        'search': json['search'] == null ? undefined : SearchRequestDtoFromJSON(json['search']),
        'paging': json['paging'] == null ? undefined : PagingRequestDtoFromJSON(json['paging']),
        'sorting': json['sorting'] == null ? undefined : CompanyOverviewDtoSortingRequestDtoFromJSON(json['sorting']),
    };
}

export function CompanyOverviewDtoFilterSortSearchPagedRequestDtoToJSON(json: any): CompanyOverviewDtoFilterSortSearchPagedRequestDto {
    return CompanyOverviewDtoFilterSortSearchPagedRequestDtoToJSONTyped(json, false);
}

export function CompanyOverviewDtoFilterSortSearchPagedRequestDtoToJSONTyped(value?: CompanyOverviewDtoFilterSortSearchPagedRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'filters': FilterRequestDtoToJSON(value['filters']),
        'search': SearchRequestDtoToJSON(value['search']),
        'paging': PagingRequestDtoToJSON(value['paging']),
        'sorting': CompanyOverviewDtoSortingRequestDtoToJSON(value['sorting']),
    };
}

